import axios from "axios";

export const baseURL = process.env.REACT_APP_API_URL;

export const axiosInstance = axios.create({baseURL: baseURL,});

export const paystackKey = process.env.REACT_APP_PAYSTACK_KEY;

export const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
